/**
 * Cover gradients aligned with the Explore card grid design (6 variants).
 * Each uses a 3-stop diagonal blend (top-left → bottom-right) for a softer match to Figma.
 */
export var EXPLORE_COVER_GRADIENTS = [
/* 1 — medium blue → bright cyan */
'linear-gradient(145deg, #4A8EF5 0%, #4EB5F7 48%, #5EDFF0 100%)',
/* 2 — emerald → mint / seafoam */
'linear-gradient(145deg, #1FAF6B 0%, #3FD89A 50%, #8AE8C8 100%)',
/* 3 — deep rose → pastel pink */
'linear-gradient(145deg, #D42A7A 0%, #E863A8 52%, #F8B8D4 100%)',
/* 4 — coral / pink-red → golden yellow */
'linear-gradient(145deg, #F0526E 0%, #F59A42 55%, #FFE566 100%)',
/* 5 — lavender purple → soft pink */
'linear-gradient(145deg, #9575E8 0%, #C49AEB 50%, #F5C6E0 100%)',
/* 6 — teal aqua → sky blue */
'linear-gradient(145deg, #1CB5A8 0%, #4DD4D0 48%, #8FE9FF 100%)'];
/** Stable index 0..5 from form id (same form always gets the same gradient). */

export var getExploreCoverGradientIndex = function getExploreCoverGradientIndex(formId) {
  var hash = 0;

  for (var i = 0; i < formId.length; i += 1) {
    hash = hash * 31 + formId.charCodeAt(i) >>> 0;
  }

  return hash % EXPLORE_COVER_GRADIENTS.length;
};
export var getExploreCoverGradient = function getExploreCoverGradient(formId) {
  return EXPLORE_COVER_GRADIENTS[getExploreCoverGradientIndex(formId)];
};